// swiper-wrapper.service.ts
import { isPlatformBrowser } from '@angular/common';
import { computed, inject, Injectable, isDevMode, PLATFORM_ID, Signal, signal } from '@angular/core';
import { register } from 'swiper/element/bundle';

@Injectable({
  providedIn: 'root'
})
export class SwiperRegisterService {
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
  private readonly _isRegistered = signal<boolean>(false);

  async load() {
    register();
  }

  /**
   * Expose registration state and trigger lazy registration automatically
   */
  readonly isRegistered: Signal<boolean> = computed(() => this._isRegistered());

  constructor() {}

  /**
   * Lazy load and register Swiper Web Components. Not used yet.
   * Since it is a dependency showing off above the fold, delaying while lazy loading it, it could impact badly the the load experience.
   */
  async lazyRegisterSwiper(): Promise<void> {
    if (!this.isBrowser) {
      return;
    }

    if (!this._isRegistered()) {
      const { register } = await import('swiper/element/bundle');
      register();
      this._isRegistered.set(true);
      if (isDevMode()) {
        console.info('Swiper components registered lazily.');
      }
    }
  }
}
